import team30 from 'assets/img/team/30.webp';
import { FileAttachment } from 'components/common/AttachmentPreview';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faFaceSmile,
  faPenToSquare,
  faReply,
  faShare,
  faTrash
} from '@fortawesome/free-solid-svg-icons';

export interface MediaItem {
  id: number;
  type: 'added' | 'received';
  mediaItem?: string;
  time: string;
  readAt: Date | string | null;
  attachments?: { images?: string[]; file?: FileAttachment };
  seen?: boolean;
}
export interface User {
  id: number;
  avatar?: string;
  status: 'online' | 'offline';
  name: string;
}
export interface AddMediaObject {
  id: number;
  user: User;
  mediaItems: MediaItem[];
  unreadMessages?: number;
}

export type TypeActionType = {
  icon: IconProp;
  label: string;
};

export const supportMedia: AddMediaObject = {
  id: 1,
  user: { id: 1, avatar: team30, status: 'online', name: 'Sharuka Nijibum' },
  mediaItems: []
};

export const suggestions: string[] = [
  'Add slide',
  'Remove slide',
  'Text',
  // 'Video',
  // 'Shape',
  'Image',
  'Edit Background',
  'Clear Slide',
  'Reset All'
];

export const actions: TypeActionType[] = [
  {
    icon: faTrash,
    label: 'Delete'
  },
  {
    icon: faReply,
    label: 'Reply'
  },
  {
    icon: faPenToSquare,
    label: 'Edit'
  },
  {
    icon: faShare,
    label: 'Share'
  },
  {
    icon: faFaceSmile,
    label: 'Emoji'
  }
];
